import loadable from '@loadable/component'
import { Switch } from 'react-router'

import AuthRoute from 'components/App/Routes/AuthRoute'
import Trip404Page from 'tripPlanner/pages/Trip404Page'

const MapView = loadable(
  () =>
    import(
      /* webpackChunkName: "TripPlannerWebViewMap" */ 'tripPlanner/pages/WebViews/components/MapView/MapView'
    ),
)

const TourAndCruiseItemSummaryView = loadable(
  () =>
    import(
      /* webpackChunkName: "TripPlannerWebViewTourAndCruiseItemSummary" */ 'tripPlanner/pages/WebViews/components/TourAndCruiseItemSummaryView/TourAndCruiseItemSummaryView'
    ),
)

const ExperienceItemSummaryView = loadable(
  () =>
    import(
      /* webpackChunkName: "TripPlannerExperienceItemSummary" */ 'tripPlanner/pages/WebViews/components/ExperienceItemSummaryView/ExperienceItemSummaryView'
    ),
)

const SavedLandingView = loadable(
  () =>
    import(
      /* webpackChunkName: "TripPlannerSavedLandingView" */ 'tripPlanner/pages/WebViews/components/SavedViewWebView/SavedViewWebView'
    ),
)

function WebViewRoutes() {
  return (
    <Switch>
      <AuthRoute
        path="/:regionCode/trip-planner/webView/:tripId/search-experience"
        component={Trip404Page}
      />
      <AuthRoute
        path="/:regionCode/trip-planner/webView/:tripId/share-trip"
        component={Trip404Page}
      />
      <AuthRoute
        path="/:regionCode/trip-planner/webView/:tripId/search-flights"
        component={Trip404Page}
      />
      <AuthRoute
        path="/:regionCode/trip-planner/webView/:tripId/search-tours-or-cruises"
        component={Trip404Page}
      />
      <AuthRoute
        path="/:regionCode/trip-planner/webView/:tripId/search-le-booking"
        component={Trip404Page}
      />
      <AuthRoute
        path="/:regionCode/trip-planner/webView/:tripId/add-to-trip"
        component={Trip404Page}
      />
      <AuthRoute
        path="/:regionCode/trip-planner/webView/:tripId/map"
        component={MapView}
      />
      <AuthRoute
        path="/:regionCode/trip-planner/webView/:tripId/custom-flight"
        component={Trip404Page}
      />
      <AuthRoute
        path="/:regionCode/trip-planner/webView/:tripId/edit-custom-flight/:itemId"
        component={Trip404Page}
      />
      <AuthRoute
        path="/:regionCode/trip-planner/webView/:tripId/tour-cruise-summary/:itemId"
        component={TourAndCruiseItemSummaryView}
      />
      <AuthRoute
        path="/:regionCode/trip-planner/webView/:tripId/experience-summary/:itemId"
        component={ExperienceItemSummaryView}
      />
      <AuthRoute
        path="/:regionCode/trip-planner/webView/saved"
        component={SavedLandingView}
      />
      <Trip404Page />
    </Switch>
  )
}

export default WebViewRoutes
